import React, { useEffect, useState } from 'react';
import { ShoppingBag, Users, UtensilsCrossed, Coins, Clock, ChefHat } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const StatCard = ({ icon: Icon, label, value, suffix, color }) => (
  <div className="bg-white rounded-2xl p-6 border border-[#D4C4AA]/40 shadow-sm">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-xs uppercase tracking-wider text-[#8B7355] font-medium">{label}</p>
        <p className="font-heading text-3xl font-bold text-[#3E2723] mt-2">
          {value}
          {suffix && <span className="text-sm font-normal text-[#6D4C41] ml-1">{suffix}</span>}
        </p>
      </div>
      <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${color}`}>
        <Icon size={20} />
      </div>
    </div>
  </div>
);

export const AdminDashboardPage = () => {
  const { axiosInstance } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axiosInstance.get('/admin/stats').then((res) => setStats(res.data));
  }, [axiosInstance]);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-3xl font-bold text-[#3E2723]">Tableau de bord</h1>
      <p className="text-[#6D4C41] mt-1 mb-8">Vue d'ensemble de votre activité</p>

      {!stats ? (
        <div className="text-[#6D4C41]/60">Chargement des statistiques…</div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            <StatCard icon={Coins} label="CA aujourd'hui" value={stats.today_revenue.toFixed(2)} suffix="CHF" color="bg-amber-100 text-amber-700" />
            <StatCard icon={ShoppingBag} label="Commandes aujourd'hui" value={stats.today_orders} color="bg-orange-100 text-orange-700" />
            <StatCard icon={Clock} label="Commandes en attente" value={stats.pending_orders} color="bg-rose-100 text-rose-700" />
            <StatCard icon={ChefHat} label="En préparation" value={stats.preparing_orders} color="bg-indigo-100 text-indigo-700" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard icon={Coins} label="CA total (payé)" value={stats.total_revenue.toFixed(2)} suffix="CHF" color="bg-emerald-100 text-emerald-700" />
            <StatCard icon={ShoppingBag} label="Total commandes" value={stats.total_orders} color="bg-blue-100 text-blue-700" />
            <StatCard icon={Users} label="Utilisateurs" value={stats.total_users} color="bg-pink-100 text-pink-700" />
            <StatCard icon={UtensilsCrossed} label="Plats au catalogue" value={stats.total_dishes} color="bg-purple-100 text-purple-700" />
          </div>
        </>
      )}
    </div>
  );
};
